import { render, staticRenderFns } from "./WrongAnalysis.vue?vue&type=template&id=2c652ef8&scoped=true"
import script from "./WrongAnalysis.vue?vue&type=script&lang=js"
export * from "./WrongAnalysis.vue?vue&type=script&lang=js"
import style0 from "./WrongAnalysis.vue?vue&type=style&index=0&id=2c652ef8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c652ef8",
  null
  
)

export default component.exports